<template>
  <div class="appointment-info">
    <v-modal
      v-show="modal.dateTime"
      @close="modal.dateTime = !modal.dateTime"
      modal-class="calendar-modal"
    >
      <Row slot="body" type="flex">
        <Col :lg="12" class="calendar-modal__item">
          <v-calendar
            :available-dates="availableDates"
            :selected-date="appointment.getDate()"
            @update="selectAppointmentDate"
          />
        </Col>
        <Col :lg="12" class="calendar-modal__item">
          <span
            v-for="(time, index) in timesBySelectedDate"
            :key="index"
            class="time-tag time-tag--bordered"
            @click="selectedTime = time"
            :class="{
              'time-tag--disabled': !time.is_free,
              'time-tag--selected': selectedTime.id === time.id,
            }"
          >
            {{ appointment.getTime() }}
          </span>
        </Col>
      </Row>

      <Row
        slot="footer"
        type="flex"
        justify="space-between"
        align="middle"
        class="calendar-modal__footer"
      >
        <Col>
          <span>Изменив дату и время ожидайте подтверждения встречи</span>
        </Col>
        <Col :lg="6">
          <v-button
            text="Готово"
            color="blue"
            fluid
            @click="changeAppointmentDate"
          />
        </Col>
      </Row>
    </v-modal>

    <v-modal
      v-show="modal.cancel"
      @close="modalHandler('cancel', false)"
      modal-class="modal-cancel"
    >
      <div slot="body">
        <p class="is-title">Вы уверены, что хотите отменить встречу?</p>

        <v-button
          text="Да, отменить"
          @click="cancelAppointment"
        />

        <span
          class="link"
          @click="modalHandler('cancel', false)"
        >
          Нет, вернуться назад
        </span>
      </div>
    </v-modal>

    <div>
      <Row
        type="flex"
        justify="space-between"
        align="middle"
        class="appointment-info__title"
      >
        <Col>
          <p class="is-subtitle">Заявка № {{ appointment.book_id }}</p>
        </Col>
        <Col>
          <v-tag
            :text="status.text"
            :color="status.color"
            :is-disabled="status.disabled"
            :bordered="status.bordered"
          />
        </Col>
      </Row>
      <Row v-if="appointment.status_comment">
        <Col>
          <div class="status-comment">{{ appointment.status_comment }}</div>
        </Col>
      </Row>

      <AppointmentRequest
        :appointment="appointment"
        :user="user"
        :partner="partner"
        @change-datetime="openSelectDateTimeModal"
      />
    </div>

    <Row type="flex" justify="center" v-if="showButtons">
      <v-button
        v-if="appointment.status === 0"
        text="Отправить нотариусу"
        class="m-r-15"
        @click="confirmAppointment"
      />
      <!-- TODO: -->
      <!-- <v-button
        text="Отменить встречу"
        color="red"
        @click="modalHandler('cancel', true)"
      /> -->
    </Row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VTag from "./VTag";
import VModal from "./VModal";
import VButton from "./VButton";
import VCalendar from "./VCalendar";
import AppointmentRequest from "./AppointmentRequest";
import { AVAILABLE_TIMES } from "@/constants/calendar";
import AppointmentService from "@/services/AppointmentService";
import { toRUDate } from '@/utilities';

import loadingMixin from "../mixins/loadingMixin";


export default {
  name: "AppointmentItemInfo",


  components: {
    VTag,
    VModal,
    VCalendar,
    VButton,
    AppointmentRequest,
  },


  mixins: [
    loadingMixin,
  ],


  props: {
    appointment: {
      type: Object,
      default: () => {}
    }
  },


  data() {
    return {
      modal: {
        cancel: false,
        dateTime: false
      },
      AVAILABLE_TIMES,
      selectedTime: AVAILABLE_TIMES[0],
      selectedDate: "",
      service: new AppointmentService(),
      // appointment: "",
      dateTitle: ""
    };
  },


  computed: {
    ...mapGetters({
      user: "user/getUser",
      userType: "getUserType"
    }),

    partner() {
      return this.user.is_client
        ? this.appointment.notary
        : this.appointment.client;
    },

    notary() {
      return this.user.is_client ? this.appointment.notary : this.user;
    },

    // appointmentNumber() {
    //   return this.$route.params.id;
    // },

    isClient() {
      return this.user ? this.user.is_client : false;
    },

    status() {
      return this.appointment.getStatusConfig();
    },

    availableDates() {
      return this.notary.getGroupedAvailableDates();
    },

    showButtons() {
      return (
        this.appointment.status >= 0 &&
        !this.appointment.checkIsArchived()
      );
    },

    timesBySelectedDate() {
      return this.selectedDate
        ? this.notary.getGroupedAvailableDates(toRUDate(this.selectedDate))
        : [];
    },

    appointmentDateTitle() {
      return {
        date: `${
          this.appointment.getWeek().weekDay
        }, ${this.appointment.getDay()}`,
        time: this.appointment.getTime()
      };
    }
  },


  // async created() {
  //   this.loading = true;
  //   this.appointment = await this.service.getAppointmentById(
  //     this.appointmentNumber
  //   );
  //   this.loading = false;
  // },


  methods: {
    selectAppointmentDate(date) {
      this.selectedDate = date.row;
    },

    async changeAppointmentDate() {
      await this.appointment.changeDateTime(this.selectedTime);
      this.modal.dateTime = false;
    },

    async openSelectDateTimeModal() {
      this.selectedTime = this.appointment.time_slot;
      await this.notary.getAvailableDates();
      this.modal.dateTime = true;
    },

    async confirmAppointment() {
      await this.appointment.confirmAppointment();
      this.$emit('refresh-appointment', this.code);
    },

    async cancelAppointment() {
      await this.appointment.cancelAppointment();
      this.modalHandler("cancel", false);
    },

    modalHandler(name, visibility) {
      this.modal[name] = visibility;
    },
  },
};
</script>

<style lang="scss">
.appointment-info {
  padding: 50px 40px;
  box-sizing: border-box;
  border-right: solid 2px $gray-lighter;
  min-height: 940px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__title {
    margin-bottom: 30px;
  }

  .status-comment {
    margin-bottom: 30px;
  }

  .calendar-modal {
    width: 830px;
    box-sizing: border-box;

    &__footer {
      background: $blue-light;
      padding: 35px 40px;
      color: $black;
    }

    &__item {
      padding: 50px 30px;
      .time-tag {
        cursor: pointer;
        text-align: center;
        width: 70px;
        height: 30px;
        line-height: 30px;
        margin: 8px;
        font-size: 15px;
        display: inline-block;
        border-radius: 3px;
        border: solid 1px transparent;

        &:hover {
          background: $blue-light;
        }

        &--bordered {
          border-color: $blue;
        }

        &--disabled {
          color: $gray;
          background: transparent !important;
          border-color: transparent;
          pointer-events: none;
        }

        &--selected {
          background: $blue !important;
          color: $white !important;
        }
      }
    }
  }

  .modal-cancel {
    padding: 80px;
    box-sizing: border-box;
    width: 480px;
    text-align: center;

    .is-title {
      margin-bottom: 40px;
    }

    .link {
      display: block;
      margin-top: 20px;
    }
  }
}
</style>
